import vFetch from "./v-fetch";

export default Vue => {
  Vue.component("v-fetch", vFetch);
};
